module.exports = __webpack_public_path__ + "static/media/addressIcon.116ed51d.svg";